/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/certification/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { CertificationFeature } from '@framework/workbench/ui/certification/certification-feature';
import Switch from '@tencent/dui/lib/components/Switch';

@Controller({ menuItems: MENU_CONFIGS })
export class CertificationController {
    /**
     * 是否显示认证标记：默认为不显示，
     */
    constructor(private readonly feature: CertificationFeature) {
    }

    @Menu(ActionType.SWITCH_CERTIFICATION, 'content')
    public getContent() {
        return i18n.t('展示官方认证信息');
    }

    @Menu(ActionType.SWITCH_CERTIFICATION, 'shouldHide')
    public hideSwitchCertification() {
        return this.feature.isCertificationHide();
    }

    @Menu(ActionType.SWITCH_CERTIFICATION, 'description')
    public getDescription() {
        return <Switch size="small" checked={window.clientVars?.docInfo?.certification.isCertification}  style={{ top: '-3px', height: '10px', width: '22px' }}/>;
    }

    @Menu(ActionType.SWITCH_CERTIFICATION, 'onClick')
    public switch() {
        this.feature.handleSwitch();
    }
}
